import { Committee } from './params.types';
import { ResponseDoc } from './response.types';
import { TaskDetails } from './task-responses.types';

export enum MEETING_STATUS {
  BROUILLON = 'BROUILLON',
  EN_RETARD = 'EN_RETARD',
  ANNULER = 'ANNULER',
  PLANIFIER = 'PLANIFIER',
  NON_PLANIFIER = 'NON_PLANIFIER',
  EN_COURS = 'EN_COURS',
  CLOTURER = 'CLOTURER',
  VALIDER = 'VALIDER',
}

export enum MeetingRoleEnum {
  PRESIDENT = 'PRESIDENT',
  MEMBER = 'MEMBRE',
}

export enum SNIPPET_TYPE {
  BY_FOLDER = 'PAR_DOSSIER',
  BY_AC = 'PAR_AC',
}

export enum DOSSIER_TYPE {
  PPM = 'PPM',
  DAC = 'DAC',
  REQUEST = 'DEMANDE',
  REPORT ='REPORT',
}

export interface Meeting {
  id: number;
  reunionNumCom: number;
  com: Committee;
  reunionDate: string;
  emplacement: string;
  object: string;
  status: MEETING_STATUS;
  reunionPpms: any[];
  reunionDacs: any[];
  reunionDemandes: MeetingRequests[];
  reunionReports:any[];
  participants: any[];
  processVerbal: any;
  haveExtraits?: boolean;
  note?: string;
  canBeCancelled?: boolean;
}

export interface MeetingRequests {
  demande: AdditiveRequest;
  ac: any;
  processInstanceId: string;
  taskId: string;
  decision: string;
  observation: string;
  docs: ResponseDoc[];
}

export interface AdditiveRequest {
  id: number;
  version: number;
  reference: string;
  typeDemande: string;
  validationStatus: string;
  description: string;
  status: string;
  etapeProcess: string;
  doc: any;
  publishedAt: string;
  avis: any[];
}

export interface MeetingDto {
  comId: number;
  reunionDate: string;
  emplacement: string;
  object: string;
  reunionPpms: PpmMeeting[];
  reunionDacs: DacMeeting[];
  reunionDemandes: DemandeDto[];
  reunionReports: ReportMeeting[];
  participants: ParticipantDto[];
  note?: string;
}

export interface DemandeDto {
  id: number;
  version: number;
  processInstanceId: string;
  taskId: string;
  decision?: string;
  observation?: string;
  files?: File[];
  docs?: ResponseDoc[];

}

export interface ReportDto {
  id: number;
  version: number;
  processInstanceId: string;
  taskId: string;
  decision?: string;
  observation?: string;
  files?: File[];
}

export interface UploadSnippetDto {
  extraitId: number;
  acId: number;
  file: File;
  extraitType: SNIPPET_TYPE;
}

export interface DownloadSnippetDto {
  reunionId: number;
  acId: number;
  extraitType: SNIPPET_TYPE;
  ppmId?: number;
  ppmVer?: number;
  dacId?: number;
  dacVer?: number;
  demandeId?: number;
  demandeVer?: number;
  reportId?: number;
  reportVer?: number;
}
export interface Snippet {
  extraitId: number;
  pvId: number;
  ac: {
    id: number;
    nom: string;
    abreviation: string;
    nomAr: string;
  };
  doc: ResponseDoc;
  dossier: Dossier;
  type: DOSSIER_TYPE;
  extraitType: SNIPPET_TYPE;
}

export interface Dossier {
  id: number;
  version: number;
  ref: string;
}

export interface PpmMeeting {
  id: number;
  version: number;
  processInstanceId: string;
  taskId: string;
  decision?: string;
  observation?: string;
  files?: File[];
  docs?: ResponseDoc[];
}

export interface DacMeeting {
  dacId: number;
  dacVer: number;
  processInstanceId: string;
  taskId: string;
  decision?: string;
  observation?: string;
  files?: File[];
  docs?: ResponseDoc[];
}
export interface ReportMeeting {
  id: number;
  version: number;
  processInstanceId: string;
  taskId: string;
  decision?: string;
  observation?: string;
  files?: File[];
  docs?: ResponseDoc[];
}
export interface RequestsTasks {
  taskId: string;
}

export interface AdditiveDetails extends TaskDetails {
  demande: any;
}

export interface Participant {
  id?: number;
  reunionId: number;
  nom: string;
  prenom: string;
  mail: string;
  present: boolean;
  fonction?: string;
  organisme?: string;
  fonctionReunion?: MeetingRoleEnum;
  userId?: string;
}

export interface ParticipantDto {
  nom: string;
  prenom: string;
  mail: string;
  present: boolean;
  id?: number;
  fonction?: string;
  organisme?: string;
  fonctionReunion?: MeetingRoleEnum;
  userId?: string;
}

export interface MeetingCpmpValidationDto {
  taskId: string;
  validate?: boolean;
  cpmpDecision?: string;
  comment: string;
}

export interface MeetingCncmpValidationDto {
  taskId: string;
  cncmpDecision: 'APPROVE' | 'REJECT_END' | 'REJECT' | 'REPORT' | 'COND_APPROVE' | 'CI';
  comment: string;
}

export interface MeetingHistory {
  id: number;
  reunionDate: string;
  emplacement: string;
  comType: string;
  object: string;
  participants: Participant[];
  processVerbal?: VerbalProcess;
  extraits?: any[];
  createdBy: string;
  updatedBy: string;
}

export interface VerbalProcess {
  id: number;
  observation?: string;
  document: PVDoc;
  metadata: any;
}

interface PVDoc {
  pvId: number;
  docId: number;
  doc: ResponseDoc;
  pv: boolean;
}

export interface PlannedDossier {
  id: number;
  version: number;
  processInstanceId: string;
  taskId: string;
  nom: string;
  ref: string;
  type: 'PPM' | 'DAC' | 'ADDITIF' | 'REPORT';
  ac: any;
  tasks?: any[];
  decision?: string;
  observation?: string;
  files?: File[];
  docs?: ResponseDoc[];
}
